import { $lang } from '@msdk/common'
import { GenericFieldValue } from '@msdk/definitions'
import { Typography } from '@msdk/ui'
import React from 'react'
import { useRecoilValue } from 'recoil'

interface Props {
  value?: GenericFieldValue
}

export function StringFieldRenderer({ value }: Props) {
  const lang = useRecoilValue($lang)
  return <Typography variant="body1">{value ? value.toStringForView(lang) : '-'}</Typography>
}
